const isPlaceholder = (prop) =>
   prop.slice(0, 2) === '${' && prop.slice(prop.length - 1) === '}';

export const getValue = (obj, prop, originalObj) => {
   return (obj ?? {})[
      isPlaceholder(prop) ? originalObj[prop.slice(2, prop.length - 1)] : prop
      ];
};

export const getObjectProperty = (obj, prop, originalObj) => {
   if (typeof prop !== 'string') return undefined;
   const [first, ...nested] = (prop ?? '').split('.');
   const value = getValue(obj, first, originalObj ?? obj);
   return nested.length
      ? getObjectProperty(value, nested.join('.'), originalObj ?? obj)
      : value;
};

export const setObjectProperty = (obj, prop, value) => {
   const [first, ...nested] = prop.split('.');
   const nestedValue = nested.length
      ? setObjectProperty(obj[first] ?? {}, nested.join('.'), value)
      : value;
   if (Array.isArray(obj)) {
      const arrayToUpdate = [...obj];
      arrayToUpdate[Number(first)] = nestedValue;
      return arrayToUpdate;
   }
   return {
      ...obj,
      [first]: nested.length
         ? setObjectProperty(obj[first] ?? {}, nested.join('.'), value)
         : value,
   };
};
